$( document ).ready(function() {
  if($('.type-form').length){
      $('.shopify-section--main-page iframe').css('min-height',$(window).height());
      $('.shopify-section--main-page').css('min-height',$(window).height());
    }
   $(window).resize(function(){
      if($(window).width() > 1024){
        if($('.show-table-content').length){
          var heightMenu = $(window).height() - 200;
          $('.menu-table-content').height(heightMenu);
        }
      }else{
        $('.menu-table-content').height('auto');
      }
     if($('.type-form').length){
      $('.shopify-section--main-page iframe').css('min-height',$(window).height());
      $('.shopify-section--main-page').css('min-height',$(window).height());
    }
    });
});
$(window).on('load', function() {
  $(document).mouseup(function(e) {
        var container = $(".ep-polite-slide-in");

        // If the container is not the target of the click, and it does not contain the target
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            container.hide();
        }
    });

  if($('.navigation-promo__wrapper').length){
      var promoHtml = $('.navigation-promo__wrapper:first').html();
      $('.parent-navigation-promo__wrapper:first').html(promoHtml);
    }
  
  if($('.type-form').length){
      $('.shopify-section--main-page iframe').css('min-height',$(window).height());
      $('.shopify-section--main-page').css('min-height',$(window).height());
    }
  
  
  if($('.show-table-content').length){
    var heightMenu = $(window).height() - 200;
    if($(window).width() > 1024){
        if($('.show-table-content').length){
          $('.menu-table-content').height(heightMenu);
        }
      }else{
        $('.menu-table-content').height('auto');
      }
    var htmlMenu = '';
    $( ".show-table-content .article-content .prose h2" ).each(function( index ) {
      var linkText = $(this).html();
      $(this).attr('id','menu-'+index);
      var htmlSubMenu = '';
      $( ".show-table-content .article-content .prose h3" ).each(function( index2 ) {
        
        if($( this ).prevAll( "h2" ).first().html() == linkText){
          var linkSubText = $(this).html();
          $(this).attr('id','sub-menu-'+index2);
          //var index3 = index2 + 1;
          htmlSubMenu += '<li><a href="#sub-menu-'+index2+'" class="menu-2 sub-menu-'+index2+'">'+linkSubText+'</a></li>';
        }
      });
      htmlMenu += '<li><a href="#menu-'+index+'" class="menu-1 menu-'+index+'">'+linkText+'</a><ul>'+htmlSubMenu+'</ul></li>';
    });
    $('.menu-table-content').html(htmlMenu);
  }

  $('.show-table-content .collection__facets h3').click(function() {
    $( this ).parent().parent().toggleClass( "active" );
  });

      var lastId,
        topMenu = $(".menu-table-content"),
        topMenuHeight = topMenu.outerHeight()-300,
        // All list items
        menuItems = topMenu.find("a.menu-1"),
        // Anchors corresponding to menu items
        scrollItems = menuItems.map(function(){
          var item = $($(this).attr("href"));
          if (item.length) { return item; }
        });
        if($(window).width() < 1000){
          topMenuHeight = topMenu.outerHeight()-15;
        }
    
    // Bind click handler to menu items
    // so we can get a fancy scroll animation
    menuItems.click(function(e){
      var href = $(this).attr("href"),
          offsetTop = href === "#" ? 0 : $(href).offset().top-topMenuHeight+1;
      $('html, body').stop().animate({ 
          scrollTop: offsetTop
      }, 300);
      e.preventDefault();
    });
    
    // Bind to scroll
    $(window).scroll(function(){
       // Get container scroll position
       var fromTop = $(this).scrollTop()+topMenuHeight;
       
       // Get id of current scroll item
       var cur = scrollItems.map(function(){
         if ($(this).offset().top < fromTop)
           return this;
       });
       // Get the id of the current element
       cur = cur[cur.length-1];
       var id = cur && cur.length ? cur[0].id : "";
       
       if (lastId !== id) {
           lastId = id;
           // Set/remove active class
           menuItems
             .parent().removeClass("active")
             .end().filter("[href='#"+id+"']").parent().addClass("active");
       }                   
    });


  var lastId2,
        topMenu2 = $(".menu-table-content"),
        topMenuHeight2 = topMenu2.outerHeight()-300,
        // All list items
        menuItems2 = topMenu2.find("a.menu-2"),
        // Anchors corresponding to menu items
        scrollItems2 = menuItems2.map(function(){
          var item2 = $($(this).attr("href"));
          if (item2.length) { return item2; }
        });
    
    // Bind click handler to menu items
    // so we can get a fancy scroll animation
    menuItems2.click(function(e){
      var href2 = $(this).attr("href"),
          offsetTop2 = href2 === "#" ? 0 : $(href2).offset().top-topMenuHeight2+1;
      $('html, body').stop().animate({ 
          scrollTop: offsetTop2
      }, 300);
      $(this).parent().addClass('active');
      $(".menu-2").parent().removeClass('active');
      e.preventDefault();
    });
    
    // Bind to scroll
    $(window).scroll(function(){
       // Get container scroll position
       var fromTop2 = $(this).scrollTop()+topMenuHeight2;
       
       // Get id of current scroll item
       var cur2 = scrollItems2.map(function(){
         if ($(this).offset().top < fromTop2)
           return this;
       });
       // Get the id of the current element
       cur2 = cur2[cur2.length-1];
       var id2 = cur2 && cur2.length ? cur2[0].id : "";
       
       if (lastId2 !== id2) {
           lastId2 = id2;
           // Set/remove active class
           menuItems2
             .parent().removeClass("active")
             .end().filter("[href='#"+id2+"']").parent().addClass("active");
       }                   
    });

    if($(".faq-block").length){
      var html = '<script type="application/ld+json">';
      html += '{';
      html += '"@context":';
      html += '"https://schema.org",';
      html += '"@type": "FAQPage",';
      html += '"mainEntity": [';
      if($( ".faq-block h3").length){
        $( ".faq-block h3" ).each(function( index ) {
        html += '{';
        html += '"@type": "Question",';
        html += '"name": "'+$(this).html()+'",';
        html += '"acceptedAnswer": {';
        html += '"@type": "Answer",';
        html += '"text": "'+$(this).next().text()+'"';
        html += '}';
        var len = $(".faq-block h3").length;
        if (index === (len - 1)){
          html += '}';
        }else{
          html += '},';
        }
        
      });
      }
      if($( ".faq-block h4").length){
        $( ".faq-block h4" ).each(function( index ) {
        html += '{';
        html += '"@type": "Question",';
        html += '"name": "'+$(this).html()+'",';
        html += '"acceptedAnswer": {';
        html += '"@type": "Answer",';
        html += '"text": "'+$(this).next().text()+'"';
        html += '}';
        var len = $(".faq-block h4").length;
        if (index === (len - 1)){
          html += '}';
        }else{
          html += '},';
        }
        
      });
      }
      
      
      html += ']';
      html += '}';
      html += '</script>';
      $(html).insertAfter(".faq-block");
    }
});